import { DEPENDENT_TYPES } from '../ChildrenInfoWorkflowConstants';

export function isEducationWorkflowDependent(dependent) {
  if (!dependent) {
    return false;
  }
  const t = dependent.Type;
  if (t === undefined || t === null) {
    return false;
  }
  //Filter only Children, GrandChildren and Other Dependents
  return (
    t === DEPENDENT_TYPES.Child ||
    t === DEPENDENT_TYPES.Grandchild ||
    t === DEPENDENT_TYPES.OtherDependent
  );
}

export function filterDependents(dependents) {
  return (dependents || []).filter(isEducationWorkflowDependent);
}
